// Mock 데이터: 이니셜, 이름, 생년월, 스크리닝 no, 랜덤 no, baseline 방문일
const MOCK_PATIENT_DATA = [
	{
		initial: 'HGS',
		name: '홍갑순',
		birth: '1959-08',
		screeningNumber: '1S-002',
		randomNumber: '1R-001',
		baselineVisitDate: '2025-02-07',
	},
	{
		initial: 'KSB',
		name: '김선분',
		birth: '1961-04',
		screeningNumber: '1S-003',
		randomNumber: '1R-002',
		baselineVisitDate: '2025-02-07',
	},
	{
		initial: 'KHS',
		name: '김향숙',
		birth: '1951-02',
		screeningNumber: '1S-006',
		randomNumber: '1R-006',
		baselineVisitDate: '2025-02-24',
	},
	{
		initial: 'AJR',
		name: '안종란',
		birth: '1947-09',
		screeningNumber: '1S-007',
		randomNumber: '1R-007',
		baselineVisitDate: '2025-02-26',
	},
	{
		initial: 'JYS',
		name: '정영숙',
		birth: '1957-01',
		screeningNumber: '1S-010',
		randomNumber: '1R-010',
		baselineVisitDate: '2025-03-14',
	},
	{
		initial: 'JGC',
		name: '정기철',
		birth: '1954-09',
		screeningNumber: '1S-011',
		randomNumber: '1R-011',
		baselineVisitDate: '2025-03-14',
	},
	{
		initial: 'YSH',
		name: '유상희',
		birth: '1949-10',
		screeningNumber: '1S-013',
		randomNumber: '1R-013',
		baselineVisitDate: '2025-04-04',
	},
	{
		initial: 'MYR',
		name: '문용례',
		birth: '1953-11',
		screeningNumber: '1S-014',
		randomNumber: '1R-014',
		baselineVisitDate: '2025-04-09',
	},
	{
		initial: 'LHJ',
		name: '이희주',
		birth: '1949-09',
		screeningNumber: '1S-018',
		randomNumber: '1R-018',
		baselineVisitDate: '2025-04-22',
	},
	{
		initial: 'KJH',
		name: '김종학',
		birth: '1959-12',
		screeningNumber: '1S-020',
		randomNumber: '1R-020',
		baselineVisitDate: '2025-04-28',
	},
	{
		initial: 'IWD',
		name: '이완덕',
		birth: '1946-10',
		screeningNumber: '1S-021',
		randomNumber: '1R-021',
		baselineVisitDate: '2025-04-28',
	},
	{
		initial: 'AMO',
		name: '안명옥',
		birth: '1957-02',
		screeningNumber: '1S-024',
		randomNumber: '1R-024',
		baselineVisitDate: '2025-04-30',
	},
	{
		initial: 'KGH',
		name: '김건흥',
		birth: '1952-04',
		screeningNumber: '1S-026',
		randomNumber: '1R-026',
		baselineVisitDate: '2025-05-14',
	},
	{
		initial: 'KNS',
		name: '김남순',
		birth: '1940-01',
		screeningNumber: '1S-028',
		randomNumber: '1R-028',
		baselineVisitDate: '2025-05-20',
	},
	{
		initial: 'PJS',
		name: '박재석',
		birth: '1962-10',
		screeningNumber: '1S-029',
		randomNumber: '1R-029',
		baselineVisitDate: '2025-05-21',
	},
	{
		initial: 'LGJ',
		name: '이광자',
		birth: '1944-10',
		screeningNumber: '1S-030',
		randomNumber: '1R-030',
		baselineVisitDate: '2025-05-21',
	},
	{
		initial: 'YGJ',
		name: '양공진',
		birth: '1954-04',
		screeningNumber: '1S-034',
		randomNumber: '1R-034',
		baselineVisitDate: '2025-05-29',
	},
	{
		initial: 'MSY',
		name: '문석렬',
		birth: '1950-11',
		screeningNumber: '1S-036',
		randomNumber: '1R-036',
		baselineVisitDate: '2025-05-30',
	},
	{
		initial: 'LJS',
		name: '임재선',
		birth: '1957-03',
		screeningNumber: '1S-037',
		randomNumber: '1R-037',
		baselineVisitDate: '2025-06-02',
	},
	{
		initial: 'LDW',
		name: '이동우',
		birth: '1959-03',
		screeningNumber: '1S-039',
		randomNumber: '1R-039',
		baselineVisitDate: '2025-06-10',
	},
	{
		initial: 'KJY',
		name: '김종엽',
		birth: '1955-01',
		screeningNumber: '3S-001',
		randomNumber: '3R-001',
		baselineVisitDate: '2025-06-11',
	},
	{
		initial: 'SOH',
		name: '송옥헌',
		birth: '1954-12',
		screeningNumber: '2S-002',
		randomNumber: '2R-002',
		baselineVisitDate: '2025-06-23',
	},
	{
		initial: 'KJ',
		name: '김준',
		birth: '1953-01',
		screeningNumber: '1S-041',
		randomNumber: '1R-041',
		baselineVisitDate: '2025-06-26',
	},
	{
		initial: 'AHS',
		name: '안학순',
		birth: '1959-09',
		screeningNumber: '3S-004',
		randomNumber: '3R-004',
		baselineVisitDate: '2025-07-09',
	},
	{
		initial: 'KGW',
		name: '권기운',
		birth: '1953-05',
		screeningNumber: '3S-006',
		randomNumber: '3R-006',
		baselineVisitDate: '2025-07-14',
	},
	{
		initial: 'KMW',
		name: '김명완',
		birth: '1957-10',
		screeningNumber: '1S-042',
		randomNumber: '1R-042',
		baselineVisitDate: '2025-07-14',
	},
	{
		initial: 'PMJ',
		name: '박만조',
		birth: '1955-08',
		screeningNumber: '3S-007',
		randomNumber: '3R-007',
		baselineVisitDate: '2025-07-15',
	},
	{
		initial: 'KDJ',
		name: '김덕준',
		birth: '1946-04',
		screeningNumber: '1S-045',
		randomNumber: '1R-045',
		baselineVisitDate: '2025-07-24',
	},
	{
		initial: 'SGC',
		name: '신경춘',
		birth: '1962-11',
		screeningNumber: '3S-011',
		randomNumber: '3R-011',
		baselineVisitDate: '2025-07-24',
	},
	{
		initial: 'KJG',
		name: '김종기',
		birth: '1954-01',
		screeningNumber: '3S-012',
		randomNumber: '3R-012',
		baselineVisitDate: '2025-07-25',
	},
	{
		initial: 'KYH',
		name: '권영호',
		birth: '1943-09',
		screeningNumber: '3S-014',
		randomNumber: '3R-014',
		baselineVisitDate: '2025-07-28',
	},
	{
		initial: 'MYG',
		name: '민윤규',
		birth: '1953-03',
		screeningNumber: '3S-016',
		randomNumber: '3R-016',
		baselineVisitDate: '2025-08-06',
	},
	{
		initial: 'YYC',
		name: '양영천',
		birth: '1958-06',
		screeningNumber: '3S-017',
		randomNumber: '3R-017',
		baselineVisitDate: '2025-08-21',
	},
	{
		initial: 'LJS',
		name: '이정신',
		birth: '1945-09',
		screeningNumber: '1S-049',
		randomNumber: '1R-048',
		baselineVisitDate: '2025-08-22',
	},
	{
		initial: 'KCS',
		name: '김창식',
		birth: '1947-01',
		screeningNumber: '3S-018',
		randomNumber: '3R-018',
		baselineVisitDate: '2025-08-25',
	},
	{
		initial: 'LYJ',
		name: '이영주',
		birth: '1956-03',
		screeningNumber: '1S-052',
		randomNumber: '1R-051',
		baselineVisitDate: '2025-08-26',
	},
	{
		initial: 'CJR',
		name: '차재록',
		birth: '1950-04',
		screeningNumber: '1S-053',
		randomNumber: '1R-052',
		baselineVisitDate: '2025-08-29',
	},
	{
		initial: 'SYI',
		name: '서영임',
		birth: '1968-04',
		screeningNumber: '2S-003',
		randomNumber: '2R-003',
		baselineVisitDate: '2025-09-03',
	},
	{
		initial: 'JKC',
		name: '장금철',
		birth: '1932-05',
		screeningNumber: '1S-055',
		randomNumber: '1R-054',
		baselineVisitDate: '2025-09-08',
	},
	{
		initial: 'KJJ',
		name: '김정자',
		birth: '1943-06',
		screeningNumber: '1S-057',
		randomNumber: '1R-056',
		baselineVisitDate: '2025-09-26',
	},
	{
		initial: 'KGJ',
		name: '김공자',
		birth: '1959-04',
		screeningNumber: '1S-058',
		randomNumber: '1R-057',
		baselineVisitDate: '2025-09-26',
	},
	{
		initial: 'KKH',
		name: '김경화',
		birth: '1954-12',
		screeningNumber: '1S-060',
		randomNumber: '1R-059',
		baselineVisitDate: '2025-09-30',
	},
	{
		initial: 'HGS',
		name: '하금실',
		birth: '1961-06',
		screeningNumber: '1S-061',
		randomNumber: '1R-060',
		baselineVisitDate: '2025-10-10',
	},
];

export default MOCK_PATIENT_DATA;

